import {
    DOWNLOAD_PROCESS_STATEMENT_PDF_REQUEST,
    downloadProcessStatementPdfFileSuccess,
    downloadProcessStatementPdfFileFailure,
} from 'Redux/Action';
import { ofType }      from 'redux-observable';
import { from, of, catchError, EMPTY } from 'rxjs';
import { mergeMap }    from 'rxjs/operators';

export function downloadProcessStatementPdfFileRequestEpic(action$, store$, { ProcessStatementRepository }) {
    return action$.pipe(
        ofType(DOWNLOAD_PROCESS_STATEMENT_PDF_REQUEST),
        mergeMap(action => {
            const { id, answerTextField } = action.payload;

            if (!`${id}`.trim()) {
                return EMPTY;
            }

            return from(ProcessStatementRepository.downloadPdfFile(id, answerTextField)).pipe(
                mergeMap(({ file, fileName }) => {
                  if(!file || !fileName) {
                    return from([
                      downloadProcessStatementPdfFileSuccess(),
                    ])
                  }
                  ProcessStatementRepository.downloadFile('application/pdf')({ content: file , filename: fileName });
                  return from([
                      downloadProcessStatementPdfFileSuccess(),
                  ]);
                }),
                catchError(error => of(downloadProcessStatementPdfFileFailure(error))),
            );
        }),
    );
}
